import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ComponentLoader } from "../component/ComponentLoader";
import { STATUS } from "../constant";

export const ConfirmationComponent = ({
  isLoading,
  modalClass,
  show,
  title,
  content,
  closeBtn,
  closeHandler,
  saveHandler,
  saveBtn,
  ContentTemplate,
  closeButton = true,
  mainContent
}) =>
  (show && (
    <Modal show={show} onHide={closeHandler} className={modalClass}>
      <ComponentLoader isLoading={isLoading === STATUS.LOADING} />
      <div className="confirm-icon" />
      <Modal.Header closeButton={closeButton} data-test="confirmation-modal">
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body
        style={{
          padding: mainContent == null ? "72px 90px 60px" : "72px 60px 60px"
        }}
      >
        <div className="confirm">Please Confirm</div>
        {mainContent == null ? null : (
          <div className="pp-confirmation-modal-issue-update-status">
            {mainContent}
          </div>
        )}
        {content || "Are you sure you want to submit?"}
      </Modal.Body>
      <Modal.Footer>
        {closeBtn || (
          <Button
            variant="secondary"
            size="sm"
            onClick={closeHandler}
            className="no-btn"
            data-test="no-button"
          >
            No
          </Button>
        )}
        {saveBtn || (
          <Button
            variant="primary"
            size="sm"
            onClick={saveHandler}
            className="btn-orange"
            data-test="yes-button"
          >
            Yes
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )) ||
  null;
